module.exports = __webpack_public_path__ + "static/media/proj17_img5.2d82eda2.jpg";